import { key } from 'core-ts-types';
import { ITimeOccurrenceDatatype } from '../../datastore/time/data_types';
import * as _4 from 'lodash4';

export interface IChangedBusyTime {
  id: key;
  tracking_id: number;
  day: string;
  from_tm: string;
  to_tm: string;
  is_new_time: boolean;
  originalTimeObj: ITimeOccurrenceDatatype;
}
export class ChangedBusyTime {
  static build(changedBusyTime: IChangedBusyTime) {
    return new ChangedBusyTime(changedBusyTime);
  }

  constructor(changedBusyTime: IChangedBusyTime) {
    _4.merge(
      this,
      {
        is_new_time: false
      },
      changedBusyTime
    );
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/builders/time/changed_busy_time_builder.ts